import { render } from "./iconArrowLeft2.vue?vue&type=template&id=71dbd7a7"
import script from "./iconArrowLeft2.vue?vue&type=script&lang=js"
export * from "./iconArrowLeft2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__